
import Dialog from '../../BaseComponents/Dialog/EDDialog';
import EDTypography from '../../BaseComponents/Typography/EDTypography';

interface IProps {
  open: boolean;
  close: () => void;
}

const BrowserRecommendationDialogView: React.FC<
  React.PropsWithChildren<IProps>
> = props => (
  <Dialog
    open={props.open}
    onClose={props.close}
    title="Du använder Internet Explorer"
    footerActions={[
      {
        label: 'ok',
        onClick: props.close,
      },
    ]}
  >
    <EDTypography>
      Då vissa funktioner kan vara ur funktion när du kör Nya Aveny genom
      Internet Explorer så rekommenderar vi att du använder en av följande
      webbläsare istället: Chrome, Firefox, Safari eller Edge.
    </EDTypography>
  </Dialog>
);

export default BrowserRecommendationDialogView;
